import { createSelector } from "reselect";
import { sectionsSelector } from "../../../sections_selector";

export const evaluationListWoundSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.evaluationListWound;
  }
);
